import { STRATEGY_FIRST_ENTRY_PERCENT_INPUT_ID } from "testIds";
import React, { useContext } from "react";
import Text from "common/Typography/Text";
import SliderAndInput from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/SliderAndInput";
import CustomInputNumber from "common/Inputs/CustomInputNumber";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { FormFieldTitle } from "features/bots/common/styles";
import { typography } from "@shared/common/Themes/typography";
import Select from "common/Select/Select";
import { BotStrategiesContext } from "@shared/features/bots/BotForm/Strategies/BotStrategies.context";
import { translateOptionName } from "@shared/common/i18n/optionNames";

const useDCAStrategyForm = () => {
  const {
    firstOrderPercentSelectorData,
    amountScaleSelectorData,
    baselineSelectorData,
  } = useContext(BotStrategiesContext)!;

  const firstOrderPercentSelector = firstOrderPercentSelectorData?.show ? (
    <>
      <FormFieldTitle
        as="div"
        style={{ display: "flex", alignItems: "center" }}
      >
        {firstOrderPercentSelectorData.title}{" "}
        <HelperTooltip {...firstOrderPercentSelectorData.helperTooltipData} />
      </FormFieldTitle>
      <CustomInputNumber
        data-testid={STRATEGY_FIRST_ENTRY_PERCENT_INPUT_ID}
        value={firstOrderPercentSelectorData.value}
        onChange={firstOrderPercentSelectorData.onChange}
        bordered={true}
        precision={firstOrderPercentSelectorData.precision}
        placeholder={firstOrderPercentSelectorData.placeholder}
        stringMode={true}
        suffix="%"
      />
      {firstOrderPercentSelectorData.error && (
        <Text
          type="danger"
          style={{ margin: "6px 0 8px 0" }}
          $size={typography.fontSizes.S}
        >
          {firstOrderPercentSelectorData.error}
        </Text>
      )}
    </>
  ) : undefined;

  const amountScaleSelector = amountScaleSelectorData?.show ? (
    <SliderAndInput
      key={amountScaleSelectorData.title}
      name={amountScaleSelectorData.title}
      value={amountScaleSelectorData.value}
      setValue={amountScaleSelectorData.onChange}
      maxValue={amountScaleSelectorData.maxValue}
      minValue={amountScaleSelectorData.minValue}
      step={amountScaleSelectorData.step}
      precision={amountScaleSelectorData.precision}
      showError={amountScaleSelectorData.showError}
      placeholder={amountScaleSelectorData.placeholder}
      helperTooltip={
        <HelperTooltip {...amountScaleSelectorData.helperTooltipData} />
      }
    />
  ) : undefined;

  const baselineSelector = baselineSelectorData?.show ? (
    <div style={{ marginBottom: 8 }} key="baselineSelector">
      <FormFieldTitle>{baselineSelectorData.title}</FormFieldTitle>
      <Select
        style={{ width: "100%" }}
        value={baselineSelectorData.value}
        onChange={baselineSelectorData.onChange}
        popupMatchSelectWidth={false}
        optionLabelProp="label"
        placeholder={baselineSelectorData.placeholder}
        options={baselineSelectorData.options?.map((option) => ({
          value: option.value,
          label: translateOptionName(option.name),
        }))}
        mobileTitle={baselineSelectorData.title}
      />
    </div>
  ) : undefined;

  return {
    amountScaleSelector,
    baselineSelector,
    firstOrderPercentSelector,
  };
};

export default useDCAStrategyForm;
